export enum ConsumerWorkflowStepStateType {
  completed = 'COMPLETED',
  incomplete = 'INCOMPLETE',
}
